import React from 'react'
import {Icon} from '@chakra-ui/react'

const MinusIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="minus-icon" {...props}>
            <path
                d="M31.76 21H9C8.45 21 8 20.55 8 20C8 19.45 8.45 19 9 19H31.76C32.31 19 32.76 19.45 32.76 20C32.76 20.55 32.31 21 31.76 21Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default MinusIcon
